const useSplashTypes = () => {
  const GET_BRAND_ID = "GET_BRAND_ID";

  return { GET_BRAND_ID };
};

export default useSplashTypes;
